import { ReactElement, ReactNode } from 'react';
import { NextPage } from 'next';

export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

export interface IDocument {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export type StripDocument<T extends IDocument> = Omit<
  T,
  'id' | 'createdAt' | 'updatedAt' | 'deletedAt'
>;

export type ObjectValues<T> = T[keyof T];

// export type TransformFileInput<T, P extends keyof T> = Omit<T, P> & {
//   [K in P]: File;
// };

// export type ReplaceFileForYup<T, P extends keyof T> = Omit<T, P> & {
//   [K in P]: unknown;
// };

export interface IPaginatedQuery {
  page: number;
  limit: number;
  orderBy?: string;
  sortBy?: string;
  sortOrder?: string;
  search?: string;
  categoryId?: string;
}

export interface IPagination {
  limit: number;
  page: number;
  totalDocs: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  currentPage: number;
}

export type ApiResponse<T> = {
  data: T;
  message?: string;
};

export type ApiResponseWithPagination<
  T,
  K extends string = 'docs',
  D = object,
  L extends string = 'stats',
> = {
  // `Record<K, T[]>` is identical to `{ [key in K]: T[] }` but is a type
  // *reference*, not a mapped-type literal. @typescript-eslint/no-unused-vars
  // (8.50.0) crashes while traversing a TSMappedType node here (a known
  // upstream bug), aborting the entire `eslint .` run with exit 2 — the inline
  // disable comments can't help because the crash happens during AST traversal,
  // before any directive is applied. Record sidesteps the crashing node.
  data: Record<K, T[]> &
    Record<L, D> & {
      pagination: IPagination;
    };
  message?: string;
};
export type ITokens = {
  accessToken: string;
  refreshToken: string;
};

export type IAuthDetails = {
  tokens: ITokens;
};

export const FileDriverValues = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  AWS_S3: 'AWS_S3',
} as const;

export type FileDriverType = (typeof FileDriverValues)[keyof typeof FileDriverValues];
export interface IFile {
  id: string;
  name: string;
  url: string;
  fileKey: string;
  originalFileKey: string;
  driver: FileDriverType;
  fileSize: number;
  cdnUrl: string;
  mimeType: string;
}
